import React from 'react';
import './YearTabs.css';

const YearTabs = ({ years, selectedYear, mediaByYear, onSelectYear }) => {
  return (
    <div className="tabs-container">
      <nav className="tabs-nav">
        {years.map((year) => (
          <button
            key={year}
            className={`tab-btn ${selectedYear === year ? 'active' : ''}`}
            onClick={() => onSelectYear(year)}
          >
            {year} ({mediaByYear[year].length})
          </button>
        ))}
      </nav>
    </div>
  );
};

export default YearTabs;